import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';

import { services } from '../../services';

export const useGetAutomationOrders = (code, params, options = {}) =>
  useQuery([QUERY_KEYS.useGetAutomationOrders, params], () => services.orders(code, params), {
    staleTime: 20 * 1000,
    ...options
  });
